/* istanbul ignore file */
import logger from '@vue-util/logger';
import $http from '@vue-util/http';

export default function handlePopUpLink(mediacontent, toggle) {
  return (e) => {
    e.preventDefault();
    let reqUrl;
    if (e.target?.href?.includes('popupFileName')) {
      const path = e.target.href.split('?')[1];
      reqUrl = `/shop/media/popup/?${path}&isAEM=true`;
    } else {
      const popupId = e.target?.href?.match(/popupOverlayId=(\d+)/)[1];
      reqUrl = `/shop/mediapopup?queryType=popup&popupID=${popupId}&isAEM=true`;
    }
    const linkText = e.target?.text || e.target?.textContent || '';
    e.target?.setAttribute('aria-label', `${linkText} link opens a modal dialog`);

    $http
      .get(reqUrl)
      .then((response) => {
        mediacontent.value = e.target?.href?.includes('popupFileName')
          ? response.data.mediacontent || { file_content: response.data }
          : response.data.mediacontent;
        toggle('popUpOverlay');
      })

      .catch((error) => {
        logger.error(`Failed API request to: ${reqUrl}`, error);
      });
  };
}
